export default "__VITE_ASSET__NaCq3Jt___"